module.exports = __webpack_public_path__ + "static/img/kb-700-377-110bb.24ea788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kb-700-377-110bb.jpg
// module id = 4kTQ
// module chunks = 0